import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IOrderConfirmationResponse } from './IOrderConfirmationResponse';

export const getOrderConfirmationDetails = (orderID: string, retailer: string): AxiosPromise<IOrderConfirmationResponse> => {
  return Fetch().then(axios => axios.get(`orders/confirmation?retailer=${retailer}&order=${orderID}`));
};
